<template>
  <div class="reset-request">
    <div class="reset-request__wrapper">
      <AppHeading tag="h2" :text="$t('pages.login.password_reset')" class="form__title" />
      <!-- subtitle -->
      <AppHeading tag="span" :text="$t('pages.login.reset_instruction')" class="form__subtitle" />
      <!-- form -->
      <AppForm @submit.prevent="requestPasswordReset" class="app-form">
        <AppInput
          class="form__input"
          v-model="$v.email.$model"
          autocomplete="off"
          :floating-label="false"
          label="Email"
          :disabled="sendingData"
          type="email"
          prepend-icon="fas fa-envelope"
        />
        <!-- error msg -->
        <p v-if="$v.email.$dirty" class="form__errors-message">
          <AppIcon :icon="validationIcon" />
          {{ $t('forms.error.email_warn') }}
        </p>
        <!-- back to login -->
        <AppRouterLink
          class="form__back-link"
          exact
          :to="{ name: 'login' }"
          :text="$t('forms.label.back_login')"
        />
        <!-- submit -->
        <SubmitButtonMagenta
          type="submit"
          :loading="sendingData"
          :disabled="$v.email.$invalid"
          spinner-color="#fff"
        >
          {{ $t('ui.buttons.send') }}
        </SubmitButtonMagenta>
      </AppForm>
    </div>
  </div>
</template>

<script>
// Utils
import { checkApiResponse } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
import { required, email } from 'vuelidate/lib/validators'
import LoginResetFormMixin from 'Mixins/Forms/loginResetForms'

export default {
  name: 'PasswordResetRequestForm',

  mixins: [LoginResetFormMixin],

  data() {
    return {
      email: '',
    }
  },

  validations: {
    email: {
      required,
      email,
    },
  },

  methods: {
    async requestPasswordReset() {
      if (this.$v.email.$invalid) return
      const notification = new Notification()
      notification.timeout = 6000
      this.toggleSendingData()

      const resetRequest = await this.$store.dispatch('user/resetUserPasswordRequest', this.email)

      if (!checkApiResponse(resetRequest)) {
        if (resetRequest.response.status === 404) {
          notification.message = this.$t('ui.notifications.error.user_not_exist')
        } else {
          notification.message = this.$t('ui.notifications.error.server_conection')
        }
      } else {
        notification.type = 'success'
        notification.message = this.$t('ui.notifications.success.email_reset_sent')
      }
      notification.dispatch()
      this.toggleSendingData()
      // reset data & validations
      this.email = ''
      this.$v.$reset()
    },
  },

  computed: {
    validationIcon() {
      return !this.$v.email.$invalid ? 'far fa-check' : 'far fa-times'
    },
  },
}
</script>

<style scoped src="@/assets/css/shared-styles/login-forms.css"></style>
<style scoped>
[class$='back-link'] {
  display: block;
  margin-top: 10px;
}
</style>
